// Copyright (c) 2020 Deere & Company

import './index.scss';

import * as busyCounter from '../../shared/action-creator/busy-counter';
import React, { Component } from 'react';
import { createErrorMessage, createSuccessMessage } from '../../shared/action-creator/alert-messages';
import { formatGivenDate, setAgGridLicense } from '../../shared/services/common-functions';
import {
    getConstraintKey, getConstraintType
} from '../../common/repositories';
import BusyCounterLoadingIndicator from '../../shared/components/busyCounter/busy-counter-loading-indicator';
import LabeledReactSelect from '../../shared/components/options-drop-down/labeled-react-select';
import OptionsDropDown from '../../shared/components/options-drop-down';
import OrderAvailabilityTable from './components/order-availability-table';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import getOrderAvailability from './repositories';
import { showLoadingIndicator } from '../../shared/state/busy-counter';
// import SelectList from '../../shared/components/options-drop-down/select-list';
import { withRouter } from 'react-router-dom';
// import Select from 'react-select';

class OrderAvailability extends Component {

    state = {
        types: [],
        keys: [],
        selectedKey: '',
        selectedType: '',
        results: [],
        selectedWeek: '',
        selectedKeyObj: null
    };

    constructor ( props ) {

        super( props );
        this.child = React.createRef();
        setAgGridLicense();

    }

    componentDidMount = () => {

        const query = new URLSearchParams( this.props.location.search );
        const queryConstraintType = query.get( 'constrainttype' );
        const queryConstraintKey = query.get( 'constraintkey' );
        const queryWeek = query.get( 'week' );

        this.props.increaseCounter();
        getConstraintType( 'ORDER_AVAILABILITY_CONSTRAINT', 'regular' ).then( response => {

            this.setState( {
                types: response
            } );
            this.props.decreaseCounter();

            if ( queryConstraintType ) {

                this.setState( {
                    selectedType: queryConstraintType
                }, () => {

                    if ( queryConstraintKey ) {

                        this.props.increaseCounter();
                        getConstraintKey( queryConstraintType ).then( resp => {

                            this.setState( {
                                keys: resp.map( item => ( {
                                    label: item.id.trim(),
                                    value: item.value.trim()
                                } ) ),
                                selectedKey: queryConstraintKey,
                                selectedKeyObj: {
                                    label: queryConstraintKey,
                                    value: queryConstraintKey
                                },
                                results: []
                            }, () => {

                                this.refresh();

                            } );
                            this.props.decreaseCounter();

                        } ).catch( () => {

                            this.props.decreaseCounter();

                        } );

                    }

                } );

            }

            if ( queryWeek ) {

                this.setState( {
                    selectedWeek: queryWeek
                } );

            }

        } ).catch( () => {

            this.props.decreaseCounter();

        } );

    }

    handleTypeChange ( val ) {

        this.setState( {
            selectedType: val,
            selectedKey: '',
            selectedKeyObj: null
        } );
        this.props.increaseCounter();
        getConstraintKey( val ).then( response => {

            const keys = response.map( item => ( {
                label: item.id.trim(),
                value: item.value.trim()
            } ) );
            this.setState( {
                keys,
                selectedKey: '',
                results: [],
                selectedWeek: ''
            } );
            this.props.decreaseCounter();

        } ).catch( () => {

            this.props.decreaseCounter();

        } );

    }

    handleKeyChange ( val ) {

        this.setState( {
            selectedKey: val.label,
            selectedKeyObj: val,
            selectedWeek: ''
        }, () => {

            this.refresh();

        } );

    }

    exportToExcel = () => {

        this.child.current.exportExcel();

    }

    processResult = res => [...res].map( i => ( i ? {
        ...i,
        weekEndingString: formatGivenDate( i.weekEnding, 'YYYY-MM-DD' )
    } : i ) );

    refresh () {

        this.props.increaseCounter();
        getOrderAvailability( this.state.selectedType, this.state.selectedKey )
            .then( response => {

                this.setState( {
                    results: response
                } );
                this.props.decreaseCounter();

            } ).catch( () => {

                this.props.decreaseCounter();

            } );

    }

    render () {

        const {
            selectedKey, selectedKeyObj, selectedType, types, keys, results, selectedWeek
        } = this.state;

        const additionalInfo = {
            ctype: selectedType,
            ckey: selectedKey,
            reportType: results.reportType,
            selectedWeek
        };
        const fullResults = results.futureAvailability ?
            [...results.orderAvailability, ...results.futureAvailability] : [];

        const fullRes = this.processResult( fullResults.map( i => (
            { ...i, unitName: this.props.unit.name, ...additionalInfo } ) ) );

        return (
            <section className="main-content">
                <BusyCounterLoadingIndicator busyCounter={this.props.busyCounter} />
                <header>
                    <h2 className="page-header">Order Availability</h2>
                </header>

                <main>
                    <section className="section-container">
                        <div className="atp-top-options atp-order-availability-top-options">
                            <div className="select-options">
                                <OptionsDropDown
                                    className="atp-order-availability-select"
                                    label="Type"
                                    isPlaceholderTranslated={true}
                                    onChange={this.handleTypeChange.bind( this )}
                                    optionDisplayAttributes={['value']}
                                    optionKey="id"
                                    options={types}
                                    placeholder="Select Type"
                                    selectedValue={selectedType}
                                />
                                {selectedType && (
                                    <LabeledReactSelect
                                        className="atp-order-availability-select"
                                        label="Key"
                                        isPlaceholderTranslated={true}
                                        onChange={this.handleKeyChange.bind( this )}
                                        optionDisplayAttributes={['value']}
                                        optionKey="id"
                                        options={keys}
                                        placeholder="Select Key"
                                        selectedValue={selectedKeyObj}
                                    />

                                )}
                                {selectedType && selectedKey && <span onClick={this.refresh.bind( this )}><i className="icon fa fa-refresh" /></span>}

                            </div>

                            <div className="export-button">
                                {selectedType && selectedKey && fullResults.length > 0 && (
                                    <button className="primary-button" type="button" onClick={this.exportToExcel.bind( this )}>
                                        <span> Export to Excel </span>
                                    </button>
                                )}
                            </div>
                        </div>
                        {selectedType && selectedKey && (
                            <OrderAvailabilityTable
                                results={fullRes}
                                oaKey={selectedKey}
                                ref={this.child}
                            />
                        )}
                    </section>
                </main>
            </section>
        );

    }

}

const mapStateToProps = state => ( {
    busyCounter: showLoadingIndicator( state.application.busyCounter ),
    unit: state.application.unit,
    accessToken: state.oktaState.oktaState.accessToken
} );

OrderAvailability.displayName = 'OrderAvailability';
OrderAvailability.propTypes = {
    busyCounter: PropTypes.bool.isRequired,
    increaseCounter: PropTypes.func.isRequired,
    decreaseCounter: PropTypes.func.isRequired,
    unit: PropTypes.object,
    location: PropTypes.object
};
const mapDispatchToProps = dispatch => ( {
    increaseCounter: () => dispatch( busyCounter.increaseBusyCounter() ),
    decreaseCounter: () => dispatch( busyCounter.decreaseBusyCounter() ),
    createSuccessMessage: message => dispatch( createSuccessMessage( message ) ),
    createErrorMessage: message => dispatch( createErrorMessage( message ) )
} );
export default connect(
    mapStateToProps, mapDispatchToProps
)( withRouter( OrderAvailability ) );
